var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          staticClass: "section top",
          staticStyle: { "flex-direction": "row", "min-width": "1600px" },
          attrs: { disabled: _vm.readonly }
        },
        [
          _c(
            "el-checkbox",
            {
              attrs: { no: "4" },
              model: {
                value: _vm.job.ams,
                callback: function($$v) {
                  _vm.$set(_vm.job, "ams", $$v)
                },
                expression: "job.ams"
              }
            },
            [_vm._v("AMS/ENS")]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "5" },
              model: {
                value: _vm.job.heating,
                callback: function($$v) {
                  _vm.$set(_vm.job, "heating", $$v)
                },
                expression: "job.heating"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Fumigation")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "6" },
              model: {
                value: _vm.job.comercialInspectation,
                callback: function($$v) {
                  _vm.$set(_vm.job, "comercialInspectation", $$v)
                },
                expression: "job.comercialInspectation"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.CommodityInspection")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "7" },
              on: {
                change: function(val) {
                  _vm.job.customsBroker = val ? _vm.job.customsBroker : 0
                  _vm.job.customsDeclarationType = val
                    ? _vm.job.customsDeclarationType
                    : -1
                }
              },
              model: {
                value: _vm.job.customs,
                callback: function($$v) {
                  _vm.$set(_vm.job, "customs", $$v)
                },
                expression: "job.customs"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.CustomsDeclaration")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "8" },
              model: {
                value: _vm.job.signMBL,
                callback: function($$v) {
                  _vm.$set(_vm.job, "signMBL", $$v)
                },
                expression: "job.signMBL"
              }
            },
            [_vm._v("MB/L")]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "9", disabled: _vm.job.mblOnly },
              model: {
                value: _vm.job.signHBL,
                callback: function($$v) {
                  _vm.$set(_vm.job, "signHBL", $$v)
                },
                expression: "job.signHBL"
              }
            },
            [_vm._v("HB/L")]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "10" },
              on: { change: _vm.mblOnlyChange },
              model: {
                value: _vm.job.mblOnly,
                callback: function($$v) {
                  _vm.$set(_vm.job, "mblOnly", $$v)
                },
                expression: "job.mblOnly"
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.DirectBusiness")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "11" },
              model: {
                value: _vm.job.salePrice,
                callback: function($$v) {
                  _vm.$set(_vm.job, "salePrice", $$v)
                },
                expression: "job.salePrice"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.SpecialPrice")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "12" },
              model: {
                value: _vm.job.availableCabinSpace,
                callback: function($$v) {
                  _vm.$set(_vm.job, "availableCabinSpace", $$v)
                },
                expression: "job.availableCabinSpace"
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AvailableCabinSpace")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "destinationPortService" },
              on: { change: _vm.destinationPortServiceChange },
              model: {
                value: _vm.job.destinationPortService,
                callback: function($$v) {
                  _vm.$set(_vm.job, "destinationPortService", $$v)
                },
                expression: "job.destinationPortService"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.PortOfDestinationServices")))]
          )
        ],
        1
      ),
      _c(
        "tab-se-booking-UICustom-layout",
        { attrs: { "element-blocks": _vm.elementBlocks } },
        [
          _vm.elementDict.jobNo.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "jobNo" }, slot: "jobNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.jobNo.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.jobNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    staticClass: "job-no-color input2",
                    attrs: { no: "12", disabled: true },
                    model: {
                      value: _vm.job.jobNo,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "jobNo", $$v)
                      },
                      expression: "job.jobNo"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.warehouseNo.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "warehouseNo" }, slot: "warehouseNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.warehouseNo.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.warehouseNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    staticClass: "input2",
                    attrs: { disabled: _vm.readonly, no: "13" },
                    model: {
                      value: _vm.job.warehouseNo,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "warehouseNo", $$v)
                      },
                      expression: "job.warehouseNo"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.quotationNo.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "quotationNo" }, slot: "quotationNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.quotationNo.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.quotationNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    staticClass: "input2",
                    attrs: {
                      no: "14",
                      value: _vm.job.quotationNo,
                      disabled: true
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customerRefNo.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customerRefNo" }, slot: "customerRefNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customerRefNo.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customerRefNo.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-input", {
                    staticClass: "input2",
                    attrs: { disabled: _vm.readonly, no: "15", trim: true },
                    model: {
                      value: _vm.job.customerRefNo,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "customerRefNo", $$v)
                      },
                      expression: "job.customerRefNo"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customerId.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customerId" }, slot: "customerId" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customerId.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customerId.label
                    },
                    slot: "label"
                  }),
                  _vm.accountObjectControlMode === 2
                    ? _c("cargo-sales-company-select", {
                        staticStyle: { flex: "1" },
                        attrs: {
                          no: "16",
                          disabled:
                            !(!_vm.job.mbl && _vm.electricBusinessBtnEnable) ||
                            _vm.readonly,
                          "method-params": { customer: true, active: true },
                          "check-credit": true,
                          job: _vm.job,
                          "default-value": _vm.job.customerId || "",
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.txtCustomerId_changeHandler(p)
                            _vm.clearPoNo()
                          }
                        }
                      })
                    : _c("cargo-company-select", {
                        staticStyle: { flex: "1" },
                        attrs: {
                          no: "16",
                          disabled:
                            !(!_vm.job.mbl && _vm.electricBusinessBtnEnable) ||
                            _vm.readonly,
                          "method-params": { customer: true, active: true },
                          "check-credit": true,
                          job: _vm.job,
                          "default-value": _vm.job.customerId || "",
                          "static-options": _vm.customerCmpList,
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: {
                          change: function(p) {
                            _vm.txtCustomerId_changeHandler(p)
                            _vm.clearPoNo()
                          }
                        }
                      })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customerContact.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customerContact" }, slot: "customerContact" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customerContact.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customerContact.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      staticClass: "input2",
                      attrs: {
                        no: "17",
                        disabled:
                          !_vm.electricBusinessBtnEnable || _vm.readonly,
                        filterable: "",
                        "allow-create": true,
                        placeholder: ""
                      },
                      on: { change: _vm.tfLinkman_closeHandler },
                      model: {
                        value: _vm.job.customerContact,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "customerContact", $$v)
                        },
                        expression: "job.customerContact"
                      }
                    },
                    _vm._l(_vm.contactList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: item.contactPerson,
                          value: item.contactPerson
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.contactTelephone.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "contactTelephone" },
                  slot: "contactTelephone"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.contactTelephone.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.contactTelephone.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    staticClass: "input2",
                    attrs: {
                      no: "18",
                      disabled: !_vm.electricBusinessBtnEnable || _vm.readonly,
                      maxlength: "32"
                    },
                    model: {
                      value: _vm.job.contactTelephone,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "contactTelephone", $$v)
                      },
                      expression: "job.contactTelephone"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.contactFax.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "contactFax" }, slot: "contactFax" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.contactFax.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.contactFax.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    staticClass: "input2",
                    attrs: {
                      no: "19",
                      disabled: !_vm.electricBusinessBtnEnable || _vm.readonly,
                      maxlength: "32"
                    },
                    model: {
                      value: _vm.job.contactFax,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "contactFax", $$v)
                      },
                      expression: "job.contactFax"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.sales.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "sales" }, slot: "sales" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.sales.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.sales.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "20",
                      disabled:
                        !(
                          !_vm.job.trustFromJob &&
                          _vm.electricBusinessBtnEnable &&
                          (!_vm.validateCustomerSales ||
                            (_vm.isSpecifiedSalesBusiness &&
                              _vm.validateCustomerSales))
                        ) || _vm.readonly,
                      "method-params": {
                        officeId:
                          !_vm.isSpecifiedSalesBusiness && _vm.salesOfficeCheck
                            ? _vm.$store.getters.currentOfficeId
                            : "",
                        category: "role",
                        shape: "sales"
                      },
                      "default-value": _vm.job.sales || "",
                      "static-options": _vm.salesList,
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    on: { change: _vm.txtSales_changeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.salesDepartment.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "salesDepartment" }, slot: "salesDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.salesDepartment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.salesDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-new-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "21",
                      disabled:
                        !(_vm.job.sales > 0 && _vm.job.salesDepartment > 0) ||
                        _vm.readonly,
                      "sales-id": _vm.job.sales,
                      "office-id": _vm.job.salesOffice,
                      "department-id": _vm.job.salesDepartment,
                      "show-office-prefix": false,
                      placeholder: " "
                    },
                    on: {
                      change: function(p) {
                        _vm.job.salesDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.salesCompany.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "salesCompany" }, slot: "salesCompany" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.salesCompany.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.salesCompany.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    staticClass: "input2",
                    attrs: {
                      no: "22",
                      disabled: true,
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    model: {
                      value: _vm.txtSalesOffice,
                      callback: function($$v) {
                        _vm.txtSalesOffice = $$v
                      },
                      expression: "txtSalesOffice"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.csr.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "csr" }, slot: "csr" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.csr.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.csr.label },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "23",
                      disabled: Boolean(_vm.job.trustFromJob) || _vm.readonly,
                      "method-params": {
                        category: "role",
                        shape: "csr",
                        officeId: _vm.job.opOffice
                      },
                      "default-value": _vm.job.csr || "",
                      "static-options": _vm.userPortRoleData.csr || _vm.csrList,
                      placeholder: " "
                    },
                    on: { change: _vm.csrChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.op.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "op" }, slot: "op" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.op.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.op.label },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "24",
                      disabled: Boolean(_vm.job.trustFromJob) || _vm.readonly,
                      "method-params": {
                        category: "role",
                        shape: "op",
                        officeId: _vm.$store.getters.currentOfficeId
                      },
                      "default-value": _vm.job.op || "",
                      placeholder: " ",
                      "static-options": _vm.userPortRoleData.op
                    },
                    on: { change: _vm.txtOPChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.opDepartment.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "opDepartment" }, slot: "opDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.opDepartment.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.opDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "25",
                      disabled: Boolean(_vm.job.trustFromJob) || _vm.readonly,
                      "office-id": _vm.job.opOffice,
                      enables: true,
                      "department-id": _vm.job.opDepartment,
                      placeholder: " "
                    },
                    on: {
                      change: function(p) {
                        _vm.job.opDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.opOffice.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "opOffice" }, slot: "opOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.opOffice.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.opOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "26",
                      disabled: _vm.isEntrustOrder() || _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_Office,
                      filterable: "",
                      "default-value": _vm.job.opOffice || "",
                      placeholder: " "
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.opOffice = p.value
                        _vm.opOfficeChargeHandler()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.siteOP.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "siteOP" }, slot: "siteOP" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.siteOP.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.siteOP.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "27",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "siteOp"
                      },
                      "default-value": _vm.job.siteOP || "",
                      placeholder: " ",
                      "static-options": _vm.userPortRoleData.siteOp
                    },
                    on: {
                      change: function(p) {
                        _vm.JobUtils.siteOpChangeHandler(_vm.job, p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoSalesId.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "cargoSalesId" }, slot: "cargoSalesId" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoSalesId.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoSalesId.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "28",
                      disabled: _vm.readonly,
                      "method-params": {
                        category: "role",
                        shape: "salesOfGoods"
                      },
                      "default-value": _vm.job.cargoSalesId || "",
                      "static-options": _vm.cargoSalesList,
                      placeholder: " "
                    },
                    on: { change: _vm.cargoSalesChargeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dc.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "dc" }, slot: "dc" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dc.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.dc.label },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "29",
                      disabled: Boolean(_vm.job.trustFromJob) || _vm.readonly,
                      "method-params": {
                        category: "role",
                        shape: "doc",
                        officeId: _vm.$store.getters.currentOfficeId
                      },
                      "default-value": _vm.job.dc || "",
                      "static-options": _vm.userPortRoleData.doc || _vm.dcList,
                      placeholder: " ",
                      "merge-load": true
                    },
                    on: { change: _vm.dcChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.planner.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "planner" }, slot: "planner" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.planner.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.planner.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "30",
                      disabled: _vm.readonly,
                      "method-params": {
                        category: "role",
                        shape: "sealine",
                        officeId: _vm.$store.getters.currentOfficeId
                      },
                      "default-value": _vm.job.planner || "",
                      placeholder: " ",
                      "static-options": _vm.userPortRoleData.seaLine,
                      "merge-load": true
                    },
                    on: { change: _vm.txtPlannerChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.overseaOp.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "overseaOp" }, slot: "overseaOp" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.overseaOp.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.overseaOp.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "overseaOp",
                    staticClass: "input2",
                    attrs: {
                      no: "overseaOp",
                      disabled: _vm.readonly,
                      placeholder: " ",
                      "default-value": _vm.job.overseaOp || "",
                      "method-params": { category: "role", shape: "overseaOp" },
                      "static-options": _vm.isHc
                        ? null
                        : _vm.userPortRoleData.overseaOp ||
                          _vm.overseaAgentUsersList,
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.job.overseaOp = p.value
                        _vm.OverseaCustomerUtils.overseaOpChangeHandler(
                          _vm.view,
                          p
                        )
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.csrDepartment.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "csrDepartment" }, slot: "csrDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.csrDepartment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.csrDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "csrDepartment",
                      disabled: _vm.readonly,
                      "office-id": Number(_vm.job.csrOffice),
                      enables: true,
                      "department-id": Number(_vm.job.csrDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.job.csrDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.csrOffice.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "csrOffice" }, slot: "csrOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.csrOffice.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.csrOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "csrOffice",
                      disabled: true,
                      "select-type": _vm.TYPE_NAMES.basic_data_Office,
                      filterable: "",
                      "default-value": _vm.job.csrOffice || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.csrOffice = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dcDepartment.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "dcDepartment" }, slot: "dcDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dcDepartment.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.dcDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "dcDepartment",
                      disabled: _vm.readonly,
                      "office-id": Number(_vm.job.dcOffice),
                      enables: true,
                      "department-id": Number(_vm.job.dcDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.job.dcDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dcOffice.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "dcOffice" }, slot: "dcOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dcOffice.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.dcOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "dcOffice",
                      disabled: true,
                      "select-type": _vm.TYPE_NAMES.basic_data_Office,
                      filterable: "",
                      "default-value": _vm.job.dcOffice || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.dcOffice = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.poNo.visible
            ? _c(
                "el-form-item",
                {
                  class: _vm.poNoRed ? "poNoClass" : "",
                  attrs: { slot: "poNo" },
                  slot: "poNo"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.poNo.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.poNo.label },
                    slot: "label"
                  }),
                  !_vm.openProjectConfig
                    ? _c("el-input", {
                        staticClass: "input2",
                        attrs: { disabled: _vm.readonly, no: "31" },
                        model: {
                          value: _vm.job.poNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "poNo", $$v)
                          },
                          expression: "job.poNo"
                        }
                      })
                    : _vm._e(),
                  _vm.openProjectConfig
                    ? _c("cargo-project-select", {
                        staticClass: "input2",
                        attrs: {
                          no: "32",
                          disabled: _vm.readonly,
                          "default-value": _vm.job.poNo,
                          "customer-id": _vm.job.customerId,
                          "is-linked": _vm.isProjectLinkedCustomer
                        },
                        on: { change: _vm.changeProject }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.plannerDepartment &&
          _vm.elementDict.plannerDepartment.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "plannerDepartment" },
                  slot: "plannerDepartment"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.plannerDepartment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.plannerDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "plannerDepartment",
                      disabled: _vm.readonly,
                      "office-id": Number(_vm.job.plannerOffice),
                      enables: true,
                      "department-id": Number(_vm.job.plannerDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.job.plannerDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.plannerOffice && _vm.elementDict.plannerOffice.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "plannerOffice" }, slot: "plannerOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.plannerOffice.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.plannerOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "plannerOffice",
                      disabled: true,
                      "select-type": _vm.TYPE_NAMES.basic_data_Office,
                      filterable: "",
                      "default-value": _vm.job.plannerOffice || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.plannerOffice = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.projectName.visible && _vm.openProjectConfig
            ? _c(
                "el-form-item",
                { attrs: { slot: "projectName" }, slot: "projectName" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.projectName.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.projectName.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    staticClass: "input2",
                    attrs: { no: "33", disabled: true },
                    model: {
                      value: _vm.job.projectName,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "projectName", $$v)
                      },
                      expression: "job.projectName"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.projectBatch.visible && _vm.openProjectConfig
            ? _c(
                "el-form-item",
                { attrs: { slot: "projectBatch" }, slot: "projectBatch" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.projectBatch.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.projectBatch.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    staticClass: "input2",
                    attrs: { disabled: _vm.readonly, no: "34" },
                    model: {
                      value: _vm.job.projectBatch,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "projectBatch", $$v)
                      },
                      expression: "job.projectBatch"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId1.visible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId1" },
                  slot: "userDefinedRoleId1"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId1.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId1.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "35",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole1"
                      },
                      "default-value": _vm.job.userDefinedRoleId1 || "",
                      placeholder: " ",
                      "static-options": _vm.userPortRoleData.userDefinedRole1,
                      "merge-load": true
                    },
                    on: { change: _vm.userDefinedRoleId1Handler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId2.visible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId2" },
                  slot: "userDefinedRoleId2"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId2.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId2.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "36",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole2"
                      },
                      "default-value": _vm.job.userDefinedRoleId2 || "",
                      placeholder: " ",
                      "static-options": _vm.userPortRoleData.userDefinedRole2,
                      "merge-load": true
                    },
                    on: { change: _vm.userDefinedRoleId2Handler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId3 &&
          _vm.elementDict.userDefinedRoleId3.slaveVisible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId3" },
                  slot: "userDefinedRoleId3"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId3.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId3.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId3",
                    attrs: {
                      no: "userDefinedRoleId3",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole3"
                      },
                      "default-value": _vm.job.userDefinedRoleId3 || "",
                      "merge-load": true,
                      "static-options": _vm.userPortRoleData.userDefinedRole3
                    },
                    on: {
                      change: function(p) {
                        _vm.userDefinedRoleId3Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId4 &&
          _vm.elementDict.userDefinedRoleId4.slaveVisible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId4" },
                  slot: "userDefinedRoleId4"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId4.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId4.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId4",
                    attrs: {
                      no: "userDefinedRoleId4",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole4"
                      },
                      "default-value": _vm.job.userDefinedRoleId4 || "",
                      "merge-load": true,
                      "static-options": _vm.userPortRoleData.userDefinedRole4
                    },
                    on: {
                      change: function(p) {
                        _vm.userDefinedRoleId4Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId5 &&
          _vm.elementDict.userDefinedRoleId5.visible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId5" },
                  slot: "userDefinedRoleId5"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId5.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId5.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId5",
                    attrs: {
                      no: "userDefinedRoleId5",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole5"
                      },
                      "default-value": _vm.job.userDefinedRoleId5 || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.userDefinedRoleId5Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId6 &&
          _vm.elementDict.userDefinedRoleId6.visible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId6" },
                  slot: "userDefinedRoleId6"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId6.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId6.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId6",
                    attrs: {
                      no: "userDefinedRoleId6",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole6"
                      },
                      "default-value": _vm.job.userDefinedRoleId6 || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.userDefinedRoleId6Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId7 &&
          _vm.elementDict.userDefinedRoleId7.visible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId7" },
                  slot: "userDefinedRoleId7"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId7.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId7.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId7",
                    attrs: {
                      no: "userDefinedRoleId7",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole7"
                      },
                      "default-value": _vm.job.userDefinedRoleId7 || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.userDefinedRoleId7Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId8 &&
          _vm.elementDict.userDefinedRoleId8.viewable &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId8" },
                  slot: "userDefinedRoleId8"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId8.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId8.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId8",
                    attrs: {
                      no: "userDefinedRoleId8",
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole8"
                      },
                      "default-multiple-value": _vm.toNumArray(
                        _vm.job.userDefinedRoleId8
                      ),
                      disabled: _vm.readonly,
                      multiple: true,
                      "merge-load": true,
                      placeholder: _vm.readonly ? " " : ""
                    },
                    on: {
                      change: function(p) {
                        _vm.job.userDefinedRoleId8 = _vm.toTxt(p.value)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.shipper.visible,
                  expression: "elementDict.shipper.visible"
                }
              ],
              staticStyle: { "margin-right": "10px" },
              attrs: {
                slot: "shipper",
                "label-width": "50px",
                "label-position": "left"
              },
              slot: "shipper"
            },
            [
              _c(
                "el-form-item",
                [
                  _c("line-label", {
                    class: _vm.elementDict.shipper.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.shipper.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    staticStyle: { display: "inline-block", width: "196px" },
                    attrs: {
                      no: "38",
                      disabled: _vm.readonly,
                      "method-params": { shipper: true, active: true },
                      "default-value": _vm.job.shipperId || "",
                      placeholder: " ",
                      "static-options": _vm.hasChooseOwnTransceiverPermission
                        ? _vm.privateShipperList
                        : null
                    },
                    on: { change: _vm.shipperChange }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "39",
                        disabled: _vm.readonly,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          _vm.billAddressDialog.visible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                  )
                ],
                1
              ),
              _vm._l(7, function(i) {
                return _c(
                  "el-form-item",
                  { key: i, attrs: { "label-width": "0" } },
                  [
                    _c("cargo-input", {
                      ref: "shipperLine" + i,
                      refInFor: true,
                      attrs: {
                        disabled: _vm.readonly,
                        no: "40",
                        "auto-uppercase": true
                      },
                      on: {
                        change: function() {
                          return _vm.wrapAddr(
                            _vm.job,
                            "shipperLine" + i,
                            i + 1 > 7 ? null : "shipperLine" + (i + 1),
                            200
                          )
                        }
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          _vm.showAdvanceTextDialog(
                            _vm.$t("SeaExport.Shipper"),
                            _vm.mergeShipperLine(),
                            _vm.splitShipperLine,
                            true
                          )
                        }
                      },
                      model: {
                        value: _vm.job["shipperLine" + i],
                        callback: function($$v) {
                          _vm.$set(_vm.job, "shipperLine" + i, $$v)
                        },
                        expression: "job['shipperLine'+i]"
                      }
                    })
                  ],
                  1
                )
              })
            ],
            2
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.consignee.visible,
                  expression: "elementDict.consignee.visible"
                }
              ],
              staticStyle: { "margin-right": "20px" },
              attrs: {
                slot: "consignee",
                "label-width": "65px",
                "label-position": "left"
              },
              slot: "consignee"
            },
            [
              _c(
                "el-form-item",
                [
                  _c("line-label", {
                    class: _vm.elementDict.consignee.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.consignee.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    staticStyle: { display: "inline-block", width: "196px" },
                    attrs: {
                      no: "66",
                      disabled: _vm.readonly,
                      "method-params": { consignee: true, active: true },
                      "default-value": _vm.job.consigneeId || "",
                      placeholder: " ",
                      "static-options": _vm.hasChooseOwnTransceiverPermission
                        ? _vm.privateConsigneeList
                        : null
                    },
                    on: { change: _vm.consigneeChange }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "67",
                        disabled: _vm.readonly,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          _vm.billAddressDialog.visible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                  )
                ],
                1
              ),
              _vm._l(7, function(i) {
                return _c(
                  "el-form-item",
                  { key: i, attrs: { "label-width": "0" } },
                  [
                    _c("cargo-input", {
                      ref: "consigneeLine" + i,
                      refInFor: true,
                      attrs: {
                        disabled: _vm.readonly,
                        no: "68",
                        "auto-uppercase": true
                      },
                      on: {
                        change: function() {
                          return _vm.wrapAddr(
                            _vm.job,
                            "consigneeLine" + i,
                            i + 1 > 7 ? null : "consigneeLine" + (i + 1),
                            200
                          )
                        }
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          _vm.showAdvanceTextDialog(
                            _vm.$t("SeaExport.Consignee"),
                            _vm.mergeConsigneeLine(),
                            _vm.splitConsigneeLine,
                            true
                          )
                        }
                      },
                      model: {
                        value: _vm.job["consigneeLine" + i],
                        callback: function($$v) {
                          _vm.$set(_vm.job, "consigneeLine" + i, $$v)
                        },
                        expression: "job['consigneeLine'+i]"
                      }
                    })
                  ],
                  1
                )
              })
            ],
            2
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.notify.visible,
                  expression: "elementDict.notify.visible"
                }
              ],
              staticStyle: { "margin-right": "20px" },
              attrs: {
                slot: "notify",
                "label-width": "50px",
                "label-position": "left"
              },
              slot: "notify"
            },
            [
              _c(
                "el-form-item",
                [
                  _c("line-label", {
                    class: _vm.elementDict.notify.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.notify.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    staticStyle: { display: "inline-block", width: "196px" },
                    attrs: {
                      no: "93",
                      disabled: _vm.readonly,
                      "method-params": { notify: true, active: true },
                      "default-value": _vm.job.notifyId || "",
                      placeholder: " ",
                      "static-options": _vm.hasChooseOwnTransceiverPermission
                        ? _vm.privateNotifyList
                        : null
                    },
                    on: { change: _vm.notifyChange }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "94",
                        disabled: _vm.readonly,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          _vm.billAddressDialog.visible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                  )
                ],
                1
              ),
              _vm._l(7, function(i) {
                return _c(
                  "el-form-item",
                  { key: i, attrs: { "label-width": "0" } },
                  [
                    _c("cargo-input", {
                      ref: "notifyLine" + i,
                      refInFor: true,
                      attrs: {
                        disabled: _vm.readonly,
                        no: "95",
                        "auto-uppercase": true
                      },
                      on: {
                        change: function() {
                          return _vm.wrapAddr(
                            _vm.job,
                            "notifyLine" + i,
                            i + 1 > 7 ? null : "notifyLine" + (i + 1),
                            200
                          )
                        }
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          _vm.showAdvanceTextDialog(
                            _vm.$t("SeaExport.NotifyParty"),
                            _vm.mergeNotifyLine(),
                            _vm.splitNotifyLine,
                            true
                          )
                        }
                      },
                      model: {
                        value: _vm.job["notifyLine" + i],
                        callback: function($$v) {
                          _vm.$set(_vm.job, "notifyLine" + i, $$v)
                        },
                        expression: "job['notifyLine'+i]"
                      }
                    })
                  ],
                  1
                )
              })
            ],
            2
          ),
          _vm.elementDict.alsoNotify.visible
            ? _c(
                "div",
                { attrs: { slot: "alsoNotify" }, slot: "alsoNotify" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.alsoNotify.isRequire ? "blue" : "",
                    staticStyle: {
                      display: "inline-block",
                      "line-height": "28px",
                      "padding-bottom": "5px"
                    },
                    attrs: { label: _vm.elementDict.alsoNotify.label }
                  }),
                  _c("br"),
                  _c("cargo-textarea", {
                    staticClass: "also-notify",
                    attrs: {
                      no: "109",
                      type: "textarea",
                      rows: 12,
                      disabled: _vm.readonly
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.alsoNotify.label,
                          _vm.job.alsoNotify,
                          function(val) {
                            _vm.job.alsoNotify = val
                          },
                          true,
                          { warningCount: 45, maxChar: 0 }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.alsoNotify,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "alsoNotify", $$v)
                      },
                      expression: "job.alsoNotify"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.etd.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "etd" }, slot: "etd" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.etd.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.etd.label },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      no: "41",
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      clearable: "",
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    on: { input: _vm.etdChange },
                    model: {
                      value: _vm.job.etd,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "etd", $$v)
                      },
                      expression: "job.etd"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.eta.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "eta" }, slot: "eta" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.eta.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.eta.label },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      no: "42",
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      clearable: ""
                    },
                    model: {
                      value: _vm.job.eta,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "eta", $$v)
                      },
                      expression: "job.eta"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsDate &&
          _vm.elementDict.customsDate.visible &&
          _vm.$store.getters.enableFrontEndPlugin
            ? _c(
                "div",
                { attrs: { slot: "customsDate" }, slot: "customsDate" },
                [
                  _c("micro-app", {
                    attrs: {
                      name: "child-operation-date-se",
                      url:
                        _vm.$store.getters.frontEndPluginUrl +
                        "/operationDateItem",
                      "router-mode": "pure",
                      destroy: ""
                    },
                    on: { datachange: _vm.operationDateDataChange }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsDate &&
          _vm.elementDict.customsDate.visible &&
          !_vm.$store.getters.enableFrontEndPlugin
            ? _c(
                "el-form-item",
                { attrs: { slot: "customsDate" }, slot: "customsDate" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customsDate.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customsDate.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      no: "customsDate",
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      clearable: ""
                    },
                    model: {
                      value: _vm.job.customsDate,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "customsDate", $$v)
                      },
                      expression: "job.customsDate"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customCutoff.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customCutoff" }, slot: "customCutoff" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customCutoff.isRequire ? "blue" : "",
                    staticStyle: { width: "100%" },
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customCutoff.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      no: "43",
                      type: "datetime",
                      format: "yyyy-MM-dd HH:mm",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      clearable: ""
                    },
                    model: {
                      value: _vm.job.customCutoff,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "customCutoff", $$v)
                      },
                      expression: "job.customCutoff"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.amsCutoff.visible && _vm.job.ams
            ? _c(
                "el-form-item",
                { attrs: { slot: "amsCutoff" }, slot: "amsCutoff" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.amsCutoff.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.amsCutoff.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      no: "44",
                      type: "datetime",
                      format: "yyyy-MM-dd HH:mm",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      clearable: ""
                    },
                    model: {
                      value: _vm.job.amsCutoff,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "amsCutoff", $$v)
                      },
                      expression: "job.amsCutoff"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.returnPeriodBegin.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "returnPeriodBegin" },
                  slot: "returnPeriodBegin"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.returnPeriodBegin.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.returnPeriodBegin.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      no: "45",
                      type: "datetime",
                      format: "yyyy-MM-dd HH:mm",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      clearable: ""
                    },
                    model: {
                      value: _vm.job.returnPeriodBegin,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "returnPeriodBegin", $$v)
                      },
                      expression: "job.returnPeriodBegin"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.returnPeriodEnd.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "returnPeriodEnd" }, slot: "returnPeriodEnd" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.returnPeriodEnd.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.returnPeriodEnd.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      no: "46",
                      type: "datetime",
                      format: "yyyy-MM-dd HH:mm",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      clearable: ""
                    },
                    model: {
                      value: _vm.job.returnPeriodEnd,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "returnPeriodEnd", $$v)
                      },
                      expression: "job.returnPeriodEnd"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dispatchingPlace.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "dispatchingPlace" },
                  slot: "dispatchingPlace"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dispatchingPlace.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.dispatchingPlace.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    staticStyle: { flex: "1" },
                    attrs: {
                      no: "dispatchingPlaceCode",
                      disabled: _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                      placeholder: _vm.$t("SeaExport.PlaceHolderPOR"),
                      filterable: "",
                      "default-value": _vm.job.dispatchingPlaceCode,
                      "tag-name": "englishName"
                    },
                    on: { parentCallBack: _vm.changeDispatchingPlaceCode }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.loadingPortCode.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "loadingPortCode" }, slot: "loadingPortCode" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.loadingPortCode.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.loadingPortCode.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "align-items": "center"
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticClass: "port-item",
                        attrs: {
                          no: "48",
                          disabled: _vm.readonly,
                          filterable: "",
                          "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                          "default-value": _vm.job.loadingPortCode,
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: { parentCallBack: _vm.loadingPortCode_Change }
                      }),
                      _vm.elementDict.transferPortCode.visible
                        ? [
                            _vm._v(" "),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "padding-left": "2px" },
                                attrs: { disabled: _vm.readonly, no: "49" },
                                model: {
                                  value: _vm.job.transfering,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "transfering", $$v)
                                  },
                                  expression: "job.transfering"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Transit")))]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.transferPortCode.visible && _vm.job.transfering
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "transferPortCode" },
                  slot: "transferPortCode"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.transferPortCode.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.transferPortCode.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "50",
                      disabled: _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                      filterable: "",
                      "default-value": _vm.job.transferPortCode,
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.transferPortCode = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dischargingPortCode.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "dischargingPortCode" },
                  slot: "dischargingPortCode"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dischargingPortCode.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.dischargingPortCode.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "51",
                      disabled:
                        !(!_vm.job.mbl && _vm.electricBusinessBtnEnable) ||
                        _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                      filterable: "",
                      "default-value": _vm.job.dischargingPortCode,
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.dischargingPortCodeChange(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.destinationPortCode.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "destinationPortCode" },
                  slot: "destinationPortCode"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.destinationPortCode.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.destinationPortCode.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "52",
                      disabled: _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                      filterable: "",
                      "default-value": _vm.job.destinationPortCode,
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.destinationPortCode_Change(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.placeOfDeliveryRegion.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "placeOfDeliveryRegion" },
                  slot: "placeOfDeliveryRegion"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.placeOfDeliveryRegion.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.placeOfDeliveryRegion.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "117",
                      disabled: _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_Region,
                      filterable: "",
                      "default-value": _vm.job.placeOfDeliveryRegion
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.placeOfDeliveryRegion = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.destinationPlace.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "destinationPlace" },
                  slot: "destinationPlace"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.destinationPlace.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.destinationPlace.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: _vm.readonly, no: "53" },
                    on: { change: _vm.changeDestinationPlace },
                    model: {
                      value: _vm.job.destinationPlace,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "destinationPlace", $$v)
                      },
                      expression: "job.destinationPlace"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoSource.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "cargoSource" }, slot: "cargoSource" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoSource.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoSource.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "54",
                      disabled: _vm.readonly,
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.local_cache_CargoSource,
                      "default-value": _vm.job.cargoSource,
                      clearable: false
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.cargoSource = p.value
                        _vm.cargoSource_Change()
                        _vm.txtCargoSourceChangeHandler()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.agentRefNo.visible && _vm.job.cargoSource === "NC"
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "agentRefNo", id: "agentRefNo" },
                  slot: "agentRefNo"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.agentRefNo.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.agentRefNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: _vm.readonly, no: "agentRefNo" },
                    model: {
                      value: _vm.job.agentRefNo,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "agentRefNo", $$v)
                      },
                      expression: "job.agentRefNo"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customJobType.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customJobType" }, slot: "customJobType" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customJobType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customJobType.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    ref: "customJobType",
                    attrs: {
                      no: "55",
                      disabled: _vm.readonly,
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.basic_data_CutomJobType,
                      "method-params": { type: _vm.job.lob, active: true },
                      "default-value": _vm.job.customJobType,
                      placeholder: _vm.$t("Message.PleaseSelect")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.customJobType = p.value
                        _vm.onCustomJobTypeChange()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.destinationAgent.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "destinationAgent" },
                  slot: "destinationAgent"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.destinationAgent.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.destinationAgent.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "56",
                      disabled: _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_Company,
                      filterable: "",
                      "method-params": {
                        overseaAgent: true,
                        companyLob: "seaExport",
                        active: true
                      },
                      "default-value": _vm.job.destinationAgent || "",
                      placeholder: " "
                    },
                    on: { parentCallBack: _vm.txtDestinationAgentChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.designationAgent.visible &&
          _vm.job.cargoSource === "NC"
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "designationAgent" },
                  slot: "designationAgent"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.designationAgent.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.designationAgent.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    attrs: {
                      no: "57",
                      disabled: _vm.readonly,
                      "method-params": { designationAgent: true, active: true },
                      "check-credit": true,
                      job: _vm.job,
                      "default-value": _vm.job.designationAgent || "",
                      "tag-name": "englishName",
                      placeholder: " "
                    },
                    on: { change: _vm.txtDesignationAgentChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.bookingAgent.visible && _vm.bookingAgentVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "bookingAgent" }, slot: "bookingAgent" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.bookingAgent.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.bookingAgent.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "58",
                      disabled: _vm.readonly,
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.basic_data_Company,
                      "method-params": {
                        bookingAgent: true,
                        companyLob: "seaExport",
                        active: true
                      },
                      "default-value": _vm.job.bookingAgent || "",
                      placeholder: " "
                    },
                    on: { parentCallBack: _vm.bookingAgentChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.terminalCompany.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "terminalCompany" }, slot: "terminalCompany" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.terminalCompany.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.terminalCompany.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "terminalCompany",
                      disabled: _vm.readonly,
                      "method-params": {
                        terminalCompany: true,
                        companyLob: "seaExport",
                        active: true
                      },
                      "default-value": _vm.job.terminalCompany || ""
                    },
                    on: {
                      change: function(p) {
                        _vm.JobUtils.terminalCompanyChangeHandler(_vm.job, p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.carrierId.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "carrierId" }, slot: "carrierId" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.carrierId.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.carrierId.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "59",
                      disabled: _vm.readonly,
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.basic_data_Company,
                      "method-params": {
                        seaCmp: true,
                        companyLob: "seaExport",
                        active: true
                      },
                      "default-value": _vm.job.carrierId || "",
                      placeholder: " "
                    },
                    on: { parentCallBack: _vm.carrierChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.scNo.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "scNo" }, slot: "scNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.scNo.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.scNo.label },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: _vm.readonly, no: "60" },
                    model: {
                      value: _vm.job.scNo,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "scNo", $$v)
                      },
                      expression: "job.scNo"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoType.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "cargoType" }, slot: "cargoType" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoType.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoType.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "61",
                      disabled: _vm.readonly,
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.basic_data_CargoType,
                      "method-params": { sea: true },
                      "default-value": _vm.job.cargoType,
                      clearable: false
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.cargoType = p.value
                        _vm.onCargoTypeChange()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.paymentTermMBL.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "paymentTermMBL" }, slot: "paymentTermMBL" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.paymentTermMBL.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.paymentTermMBL.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-require-advance-select", {
                    attrs: {
                      no: "62",
                      disabled: _vm.readonly,
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.basic_data_PaymentTerm,
                      "default-value": _vm.job.paymentTermMBL,
                      clearable: false
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.paymentTermMBL = p.value
                        _vm.portChange()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.placeOfMblPayment.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "placeOfMblPayment" },
                  slot: "placeOfMblPayment"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.placeOfMblPayment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.placeOfMblPayment.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "63",
                      disabled:
                        _vm.job.paymentTermMBL === "CC" ||
                        _vm.job.paymentTermMBL === "PPAC" ||
                        _vm.readonly
                    },
                    model: {
                      value: _vm.mblDoc.paymentPlaceBL,
                      callback: function($$v) {
                        _vm.$set(_vm.mblDoc, "paymentPlaceBL", $$v)
                      },
                      expression: "mblDoc.paymentPlaceBL"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.paymentTermHBL.visible && !_vm.job.mblOnly
            ? _c(
                "el-form-item",
                { attrs: { slot: "paymentTermHBL" }, slot: "paymentTermHBL" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.paymentTermHBL.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.paymentTermHBL.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-require-advance-select", {
                    attrs: {
                      no: "64",
                      disabled: _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_PaymentTerm,
                      filterable: "",
                      clearable: false,
                      "default-value": _vm.job.paymentTermHBL
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.paymentTermHBL = p.value
                        _vm.portChange()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.placeOfHblPayment.visible && !_vm.job.mblOnly
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "placeOfHblPayment" },
                  slot: "placeOfHblPayment"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.placeOfHblPayment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.placeOfHblPayment.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: _vm.readonly, no: "65" },
                    model: {
                      value: _vm.hdoc.paymentPlaceBL,
                      callback: function($$v) {
                        _vm.$set(_vm.hdoc, "paymentPlaceBL", $$v)
                      },
                      expression: "hdoc.paymentPlaceBL"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.vessel.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "vessel" }, slot: "vessel" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.vessel.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.vessel.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "69",
                      disabled: _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.static_data_Vessel,
                      cache: false,
                      filterable: "",
                      "allow-create": true,
                      "default-value": _vm.job.vessel,
                      "static-options": _vm.vesselList,
                      placeholder: " "
                    },
                    on: { parentCallBack: _vm.onVesselSelectionChange }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.voyageFlight.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "voyageFlight" }, slot: "voyageFlight" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.voyageFlight.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.voyageFlight.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    ref: "voyageFlight",
                    attrs: {
                      no: "70",
                      disabled: _vm.readonly,
                      cache: false,
                      filterable: "",
                      clearable: "",
                      "allow-create": true,
                      "default-value": _vm.job.voyageFlight,
                      "tag-name": "voyageNo",
                      "tag-value": "voyageNo",
                      "static-options": _vm.voyages,
                      placeholder: " "
                    },
                    on: {
                      focus: _vm.txtVoyageFocusInHandler,
                      parentCallBack: function(p) {
                        _vm.job.voyageFlight = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.vesselIMO.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "vesselIMO" }, slot: "vesselIMO" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.vesselIMO.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.vesselIMO.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: _vm.readonly, no: "71" },
                    model: {
                      value: _vm.job.vesselIMO,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "vesselIMO", $$v)
                      },
                      expression: "job.vesselIMO"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.bargeCustomCutoff.visible
            ? _c(
                "template",
                { slot: "bargeCustomCutoff" },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("line-label", {
                        class: _vm.elementDict.bargeCustomCutoff.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.bargeCustomCutoff.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-checkbox", {
                            attrs: { disabled: _vm.readonly, no: "72" },
                            model: {
                              value: _vm.showBargeCustomCutoff,
                              callback: function($$v) {
                                _vm.showBargeCustomCutoff = $$v
                              },
                              expression: "showBargeCustomCutoff"
                            }
                          }),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showBargeCustomCutoff,
                                  expression: "showBargeCustomCutoff"
                                }
                              ],
                              staticStyle: { "margin-left": "10px" }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("Sales.Barge")) +
                                    _vm._s(
                                      _vm.$t("SeaExport.BargeCYCutOffDate2")
                                    )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showBargeCustomCutoff,
                          expression: "showBargeCustomCutoff"
                        }
                      ]
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled: _vm.readonly,
                          no: "73",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          clearable: ""
                        },
                        model: {
                          value: _vm.job.bargeCustomCutoff,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "bargeCustomCutoff", $$v)
                          },
                          expression: "job.bargeCustomCutoff"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.bargePOL.visible && _vm.showBargeCustomCutoff
            ? _c(
                "el-form-item",
                { attrs: { slot: "bargePOL" }, slot: "bargePOL" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.bargePOL.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.bargePOL.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: _vm.readonly, no: "74" },
                    model: {
                      value: _vm.job.bargePOL,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "bargePOL", $$v)
                      },
                      expression: "job.bargePOL"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.vesselLineCode.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "vesselLineCode" }, slot: "vesselLineCode" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.vesselLineCode.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.vesselLineCode.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: _vm.readonly, no: "75" },
                    model: {
                      value: _vm.job.vesselLineCode,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "vesselLineCode", $$v)
                      },
                      expression: "job.vesselLineCode"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.inquiryPriceNo &&
          _vm.elementDict.inquiryPriceNo.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "inquiryPriceNo" }, slot: "inquiryPriceNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.inquiryPriceNo.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.inquiryPriceNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    staticClass: "input2",
                    attrs: {
                      no: "inquiryPriceNo",
                      value: _vm.job.inquiryPriceNo,
                      disabled: ""
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.prePortQuotationNo &&
          _vm.elementDict.prePortQuotationNo.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "prePortQuotationNo" },
                  slot: "prePortQuotationNo"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.prePortQuotationNo.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.prePortQuotationNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    staticClass: "input2",
                    attrs: {
                      no: "prePortQuotationNo",
                      value: _vm.job.prePortQuotationNo,
                      disabled: ""
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.lastMileQuotationNo &&
          _vm.elementDict.lastMileQuotationNo.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "lastMileQuotationNo" },
                  slot: "lastMileQuotationNo"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.lastMileQuotationNo.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.lastMileQuotationNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    staticClass: "input2",
                    attrs: {
                      no: "lastMileQuotationNo",
                      value: _vm.job.lastMileQuotationNo,
                      disabled: ""
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.containerLoadType.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "containerLoadType" },
                  slot: "containerLoadType"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.containerLoadType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.containerLoadType.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        no: "containerLoadType",
                        disabled: _vm.readonly
                      },
                      on: {
                        change: function($event) {
                          return _vm.containerLoadType_Change()
                        }
                      },
                      model: {
                        value: _vm.job.containerLoadType,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "containerLoadType", $$v)
                        },
                        expression: "job.containerLoadType"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          value: "FCL",
                          label: _vm.$t("CargoMsg.Cargo_FCL")
                        }
                      }),
                      _c("el-option", {
                        attrs: {
                          value: "LCL",
                          label: _vm.$t("CargoMsg.Cargo_DirectConsol")
                        }
                      }),
                      _c("el-option", {
                        attrs: {
                          value: "BB",
                          label: _vm.$t("CargoMsg.Cargo_CoLoadConsol")
                        }
                      }),
                      _c("el-option", {
                        attrs: { value: "BC", label: "Buyer Console" }
                      }),
                      _c("el-option", {
                        attrs: {
                          value: "BULK",
                          label: _vm.$t("CargoMsg.Cargo_BulkCargo")
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "template",
            { slot: "seaEq" },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.seaEq.visible &&
                        (_vm.job.containerLoadType === "FCL" ||
                          _vm.job.containerLoadType === "BB"),
                      expression:
                        "elementDict.seaEq.visible && (job.containerLoadType==='FCL'||job.containerLoadType==='BB')"
                    }
                  ],
                  attrs: { "label-width": "0" }
                },
                [
                  _c("booking-sea-eq-data-grid", {
                    ref: "bookingSeaEqDataGrid",
                    attrs: {
                      value: _vm.seaEqList,
                      "container-load-type": _vm.job.containerLoadType,
                      "is-edit": _vm.isEdit,
                      job: _vm.job,
                      "hide-soc": true
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.elementDict.seaEq.visible &&
                        (_vm.job.containerLoadType === "FCL" ||
                          _vm.job.containerLoadType === "BB"),
                      expression:
                        "elementDict.seaEq.visible && (job.containerLoadType==='FCL'||job.containerLoadType==='BB')"
                    }
                  ],
                  attrs: { "label-width": "0" }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      style: { marginRight: "10px" },
                      attrs: { disabled: _vm.readonly },
                      on: { change: _vm.socChange },
                      model: {
                        value: _vm.job.soc,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "soc", $$v)
                        },
                        expression: "job.soc"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Soc")))]
                  ),
                  _c(
                    "el-radio-group",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.soc,
                          expression: "job.soc"
                        }
                      ],
                      style: { marginTop: "2px", marginLeft: "25px" },
                      attrs: { disabled: _vm.readonly, no: "118" },
                      model: {
                        value: _vm.job.socType,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "socType", $$v)
                        },
                        expression: "job.socType"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.CargoOwnerSOC")))
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.ForwarderSOC")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.quantityConsignActual.visible,
                  expression: "elementDict.quantityConsignActual.visible"
                }
              ],
              attrs: { slot: "quantityConsignActual" },
              slot: "quantityConsignActual"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.quantityConsignActual.isRequire
                  ? "blue"
                  : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.quantityConsignActual.label
                },
                slot: "label"
              }),
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("auto-number-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "77",
                      precision: 0,
                      min: 0
                    },
                    on: { change: _vm.quantityContractChange },
                    model: {
                      value: _vm.job.quantityContract,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "quantityContract", $$v)
                      },
                      expression: "job.quantityContract"
                    }
                  }),
                  _c("span", { staticStyle: { padding: "0 2px" } }, [
                    _vm._v("/")
                  ]),
                  _c("auto-number-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "78",
                      precision: 0,
                      min: 0
                    },
                    on: { change: _vm.quantityActualChange },
                    model: {
                      value: _vm.job.quantityActual,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "quantityActual", $$v)
                      },
                      expression: "job.quantityActual"
                    }
                  }),
                  _c("span", [_vm._v("PCS")])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.weightConsignActual.visible,
                  expression: "elementDict.weightConsignActual.visible"
                }
              ],
              attrs: { slot: "weightConsignActual" },
              slot: "weightConsignActual"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.weightConsignActual.isRequire
                  ? "blue"
                  : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.weightConsignActual.label
                },
                slot: "label"
              }),
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("auto-number-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "79",
                      precision: 3,
                      min: 0
                    },
                    on: { change: _vm.weightContractChange },
                    model: {
                      value: _vm.job.weightContract,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "weightContract", $$v)
                      },
                      expression: "job.weightContract"
                    }
                  }),
                  _c("span", { staticStyle: { padding: "0 2px" } }, [
                    _vm._v("/")
                  ]),
                  _c("auto-number-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "80",
                      precision: 3,
                      min: 0
                    },
                    on: { change: _vm.weightActualChange },
                    model: {
                      value: _vm.job.weightActual,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "weightActual", $$v)
                      },
                      expression: "job.weightActual"
                    }
                  }),
                  _c("span", [_vm._v("KGS")])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.cubageConsignActual.visible,
                  expression: "elementDict.cubageConsignActual.visible"
                }
              ],
              attrs: { slot: "cubageConsignActual" },
              slot: "cubageConsignActual"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.cubageConsignActual.isRequire
                  ? "blue"
                  : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.cubageConsignActual.label
                },
                slot: "label"
              }),
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("auto-number-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "81",
                      precision: 3,
                      min: 0
                    },
                    on: { change: _vm.cubageContractChange },
                    model: {
                      value: _vm.job.cubageContract,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "cubageContract", $$v)
                      },
                      expression: "job.cubageContract"
                    }
                  }),
                  _c("span", { staticStyle: { padding: "0 2px" } }, [
                    _vm._v("/")
                  ]),
                  _c("auto-number-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "82",
                      precision: 3,
                      min: 0
                    },
                    on: { change: _vm.cubageActualChange },
                    model: {
                      value: _vm.job.cubageActual,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "cubageActual", $$v)
                      },
                      expression: "job.cubageActual"
                    }
                  }),
                  _c("span", [_vm._v("CBM")])
                ],
                1
              )
            ],
            1
          ),
          _vm.elementDict.packing.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "packing" }, slot: "packing" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.packing.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.packing.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-packing-select", {
                    attrs: {
                      no: "83",
                      disabled: _vm.readonly,
                      "default-value": _vm.job.packing,
                      placeholder: " "
                    },
                    on: {
                      change: function(p) {
                        _vm.job.packing = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.insideQuantity.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "insideQuantity" }, slot: "insideQuantity" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.insideQuantity.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.insideQuantity.label
                    },
                    slot: "label"
                  }),
                  _c("auto-number-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "84",
                      precision: 0,
                      min: 0
                    },
                    model: {
                      value: _vm.job.insideQuantity,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "insideQuantity", $$v)
                      },
                      expression: "job.insideQuantity"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.chargeWeight.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "chargeWeight" }, slot: "chargeWeight" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.chargeWeight.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.chargeWeight.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled: _vm.readonly,
                          no: "85",
                          controls: false,
                          precision: 3
                        },
                        model: {
                          value: _vm.job.chargeWeight,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "chargeWeight", $$v)
                          },
                          expression: "job.chargeWeight"
                        }
                      }),
                      _c("span", [_vm._v("M/T")])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.insidePacking.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "insidePacking" }, slot: "insidePacking" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.insidePacking.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.insidePacking.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-packing-select", {
                    attrs: {
                      no: "86",
                      disabled: _vm.readonly,
                      "default-value": _vm.job.insidePacking,
                      placeholder: " "
                    },
                    on: {
                      change: function(p) {
                        _vm.job.insidePacking = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.measurements.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "measurements" }, slot: "measurements" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.measurements.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.measurements.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "87",
                      type: "textarea",
                      rows: 3
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.measurements.label,
                          _vm.job.measurements,
                          function(val) {
                            _vm.job.measurements = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.measurements,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "measurements", $$v)
                      },
                      expression: "job.measurements"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.salePriceRemarks.visible && _vm.job.salePrice
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "salePriceRemarks" },
                  slot: "salePriceRemarks"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.salePriceRemarks.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.salePriceRemarks.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "88",
                      type: "textarea",
                      rows: 3
                    },
                    model: {
                      value: _vm.job.salePriceRemarks,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "salePriceRemarks", $$v)
                      },
                      expression: "job.salePriceRemarks"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.freightTerm.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "freightTerm" }, slot: "freightTerm" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.freightTerm.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.freightTerm.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "89",
                      disabled: _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_ShippingTerm,
                      filterable: "",
                      clearable: false,
                      "default-value": _vm.job.freightTerm
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.freightTerm = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.freightTermHBL.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "freightTermHBL" }, slot: "freightTermHBL" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.freightTermHBL.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.freightTermHBL.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "90",
                      disabled: _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_ShippingTerm,
                      filterable: "",
                      clearable: false,
                      "default-value": _vm.job.freightTermHBL
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.freightTermHBL = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.incoTerm.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "incoTerm" }, slot: "incoTerm" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.incoTerm.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.incoTerm.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "91",
                      disabled: _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_IncoTerm,
                      filterable: "",
                      clearable: false,
                      "default-value": _vm.job.incoTerm
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.incoTerm = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.bookingTerm.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "bookingTerm" }, slot: "bookingTerm" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.bookingTerm.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.bookingTerm.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-require-select", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "92",
                      options: _vm.bookingTerms,
                      "label-field": _vm.isZh ? "chineseName" : "englishName",
                      "value-field": "code",
                      clearable: false,
                      size: "mini"
                    },
                    model: {
                      value: _vm.job.bookingTerm,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "bookingTerm", $$v)
                      },
                      expression: "job.bookingTerm"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.freeTime.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "freeTime" }, slot: "freeTime" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.freeTime.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.freeTime.label
                    },
                    slot: "label"
                  }),
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      no: "96",
                      controls: false
                    },
                    on: {
                      input: function(val) {
                        _vm.job.freeDetention = val
                      }
                    },
                    model: {
                      value: _vm.job.freeTime,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "freeTime", $$v)
                      },
                      expression: "job.freeTime"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoChineseName.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "cargoChineseName" },
                  slot: "cargoChineseName"
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoChineseName.isRequire
                          ? "blue"
                          : "",
                        attrs: { label: _vm.elementDict.cargoChineseName.label }
                      }),
                      _c("br"),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isEdit,
                              expression: "isEdit"
                            }
                          ],
                          attrs: {
                            no: "ChineseDescriptionOfGoods",
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              _vm.showHsCodeSearchDialog(
                                _vm.$t("Message.SelectCargoChineseName"),
                                function(p) {
                                  return (_vm.job.cargoChineseName =
                                    p.commodityName)
                                }
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Search")) + " ")]
                      )
                    ],
                    1
                  ),
                  _c("cargo-textarea", {
                    attrs: {
                      no: "cargoChineseName",
                      disabled: !_vm.isEdit,
                      type: "textarea",
                      rows: 5
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.cargoChineseName.label,
                          _vm.job.cargoChineseName,
                          function(val) {
                            _vm.job.cargoChineseName = val
                          },
                          true,
                          { autoUppercase: true }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.cargoChineseName,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "cargoChineseName", $$v)
                      },
                      expression: "job.cargoChineseName"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoEnglishName.visible
            ? _c(
                "template",
                { slot: "cargoEnglishName" },
                [
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        }
                      ]
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { no: "Copy2", type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.transcribeDialog.visible = true
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Copy2")) + " ")]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoEnglishName.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoEnglishName.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-textarea", {
                        attrs: {
                          no: "cargoEnglishName",
                          type: "textarea",
                          rows: 5,
                          disabled: !_vm.isEdit,
                          "auto-uppercase": _vm.isUppercaseByConfig
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            return _vm.showAdvanceTextDialog(
                              _vm.elementDict.cargoEnglishName.label,
                              _vm.job.cargoEnglishName,
                              function(val) {
                                _vm.job.cargoEnglishName = val
                              },
                              _vm.isUppercaseByConfig,
                              { autoUppercase: _vm.isUppercaseByConfig }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.cargoEnglishName,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cargoEnglishName", $$v)
                          },
                          expression: "job.cargoEnglishName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.hsCode.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "hsCode" }, slot: "hsCode" },
                [
                  _c(
                    "div",
                    { attrs: { slot: "label" }, slot: "label" },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.hsCode.isRequire ? "blue" : "",
                        attrs: { label: _vm.elementDict.hsCode.label }
                      }),
                      _c("br"),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isEdit,
                              expression: "isEdit"
                            }
                          ],
                          attrs: { no: "Search", type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.showHsCodeSearchDialog(
                                _vm.$t("Message.SelectHsCode"),
                                function(val) {
                                  _vm.job.hsCode = val.code
                                }
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Search")) + " ")]
                      )
                    ],
                    1
                  ),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "hsCode",
                      type: "textarea",
                      rows: 5
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.hsCode.labe,
                          _vm.job.hsCode,
                          function(val) {
                            _vm.job.hsCode = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.hsCode,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "hsCode", $$v)
                      },
                      expression: "job.hsCode"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.mark.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "mark" }, slot: "mark" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.mark.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.mark.label },
                    slot: "label"
                  }),
                  _c("cargo-rich-textarea", {
                    staticStyle: {
                      height: "65px",
                      "min-height": "65px",
                      flex: "1"
                    },
                    attrs: {
                      no: "100",
                      "text-chars": 0,
                      "warning-count": -1,
                      disabled: !_vm.isEdit,
                      "auto-uppercase": _vm.isUppercaseByConfig
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.mark.label,
                          _vm.job.mark,
                          function(val) {
                            _vm.job.mark = val
                          },
                          _vm.isUppercaseByConfig,
                          { autoUppercase: _vm.isUppercaseByConfig }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.mark,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "mark", $$v)
                      },
                      expression: "job.mark"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoCode.visible
            ? _c(
                "template",
                { slot: "cargoCode" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CategoryOfGoods") } },
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoCode.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "101",
                          "select-type":
                            _vm.TYPE_NAMES.basic_data_CargoInformation,
                          disabled: _vm.readonly,
                          filterable: "",
                          clearable: true,
                          "default-value": _vm.job.cargoCode,
                          "allow-create": false
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.cargoCodeChange(p.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: {
                          no: "102",
                          disabled:
                            !(
                              _vm.isEdit &&
                              _vm.job.cargoCode != "" &&
                              _vm.job.cargoCode != null
                            ) || _vm.readonly
                        },
                        model: {
                          value: _vm.job.cargoName,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cargoName", $$v)
                          },
                          expression: "job.cargoName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsBroker.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customsBroker" }, slot: "customsBroker" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customsBroker.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customsBroker.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "103",
                      disabled: !_vm.job.customs || _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_Company,
                      "data-filter-function": _vm.customsBrokerFilter,
                      filterable: "",
                      "default-value": _vm.job.customsBroker || "",
                      placeholder: _vm.$t(
                        "SeaExport.PleaseTickCustomsDeclarationOption"
                      ),
                      "method-params": {
                        customsBroker: true,
                        companyLob: "seaExport",
                        active: true
                      }
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.customsBrokerChangeHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsDeclarationType.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "customsDeclarationType" },
                  slot: "customsDeclarationType"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customsDeclarationType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customsDeclarationType.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "customsDeclarationType",
                      disabled: !_vm.job.customs || _vm.readonly,
                      "select-type":
                        _vm.TYPE_NAMES.basic_data_CustomsDeclarationType,
                      filterable: "",
                      "default-value":
                        _vm.job.customsDeclarationType === -1
                          ? ""
                          : _vm.job.customsDeclarationType,
                      placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.customsDeclarationType = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.haulageCompany.visible && !_vm.isSalesForSzfs
            ? _c(
                "el-form-item",
                { attrs: { slot: "haulageCompany" }, slot: "haulageCompany" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.haulageCompany.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.haulageCompany.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    attrs: {
                      no: "104",
                      disabled: !_vm.job.landTransportation || _vm.readonly,
                      "method-params": { truckCmp: true, active: true },
                      "default-value": _vm.job.carryingCmp || "",
                      placeholder: _vm.$t(
                        "SeaExport.PleaseTickDoorLoadingDeliveryOption"
                      )
                    },
                    on: { change: _vm.carryingCmpChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.elementDict.doorName.visible &&
                    _vm.job.landTransportation,
                  expression:
                    "elementDict.doorName.visible && job.landTransportation"
                }
              ],
              attrs: { slot: "doorName" },
              slot: "doorName"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.doorName.isRequire ? "blue" : "",
                attrs: { slot: "label", label: _vm.elementDict.doorName.label },
                slot: "label"
              }),
              _c(
                "el-select",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    no: "105",
                    "value-key": "name",
                    clearable: "",
                    filterable: "",
                    "allow-create": true
                  },
                  on: { change: _vm.doorsChangeHandler },
                  model: {
                    value: _vm.truckingInfo.doorName,
                    callback: function($$v) {
                      _vm.$set(_vm.truckingInfo, "doorName", $$v)
                    },
                    expression: "truckingInfo.doorName"
                  }
                },
                _vm._l(_vm.doorList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.name, value: item.name }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.elementDict.contactPerson.visible &&
                    _vm.job.landTransportation,
                  expression:
                    "elementDict.contactPerson.visible && job.landTransportation"
                }
              ],
              attrs: { slot: "contactPerson" },
              slot: "contactPerson"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.contactPerson.isRequire ? "blue" : "",
                attrs: {
                  slot: "label",
                  label: _vm.elementDict.contactPerson.label
                },
                slot: "label"
              }),
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("el-input", {
                    staticClass: "short-el-input",
                    attrs: {
                      disabled: _vm.readonly,
                      no: "106",
                      placeholder: _vm.$t("Payment.contactPerson")
                    },
                    model: {
                      value: _vm.truckingInfo.doorMan,
                      callback: function($$v) {
                        _vm.$set(_vm.truckingInfo, "doorMan", $$v)
                      },
                      expression: "truckingInfo.doorMan"
                    }
                  }),
                  _c(
                    "div",
                    {
                      class: _vm.elementDict.contactPerson.isRequire
                        ? "blue"
                        : "",
                      staticStyle: {
                        width: "67px",
                        padding: "0 5px",
                        "font-size": "12px",
                        "text-align": "right"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Tel")))]
                  ),
                  _c("el-input", {
                    staticClass: "short-el-input",
                    attrs: {
                      disabled: _vm.readonly,
                      no: "107",
                      placeholder: _vm.$t("SeaExport.Tel")
                    },
                    model: {
                      value: _vm.truckingInfo.doorManTel,
                      callback: function($$v) {
                        _vm.$set(_vm.truckingInfo, "doorManTel", $$v)
                      },
                      expression: "truckingInfo.doorManTel"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.elementDict.doorAddr.visible &&
                    _vm.job.landTransportation,
                  expression:
                    "elementDict.doorAddr.visible && job.landTransportation"
                }
              ],
              attrs: { slot: "doorAddr" },
              slot: "doorAddr"
            },
            [
              _c("line-label", {
                class: _vm.elementDict.doorAddr.isRequire ? "blue" : "",
                attrs: { slot: "label", label: _vm.elementDict.doorAddr.label },
                slot: "label"
              }),
              _c("el-input", {
                attrs: {
                  disabled: _vm.readonly,
                  no: "108",
                  type: "textarea",
                  rows: 3
                },
                nativeOn: {
                  dblclick: function($event) {
                    _vm.showAdvanceTextDialog(
                      _vm.$t("SeaExport.DoorAddress"),
                      _vm.truckingInfo.doorAddr,
                      function(val) {
                        _vm.truckingInfo.doorAddr = val
                      },
                      true,
                      { maxChar: 0 }
                    )
                  }
                },
                model: {
                  value: _vm.truckingInfo.doorAddr,
                  callback: function($$v) {
                    _vm.$set(_vm.truckingInfo, "doorAddr", $$v)
                  },
                  expression: "truckingInfo.doorAddr"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.elementDict.loadingDate &&
                    _vm.elementDict.loadingDate.visible &&
                    _vm.job.landTransportation,
                  expression:
                    "elementDict.loadingDate && elementDict.loadingDate.visible && job.landTransportation"
                }
              ],
              attrs: { slot: "loadingDate" },
              slot: "loadingDate"
            },
            [
              _c("line-label", {
                class:
                  _vm.elementDict.loadingDate &&
                  _vm.elementDict.loadingDate.isRequire
                    ? "blue"
                    : "",
                attrs: {
                  slot: "label",
                  label:
                    _vm.elementDict.loadingDate &&
                    _vm.elementDict.loadingDate.label
                },
                slot: "label"
              }),
              _c("el-date-picker", {
                staticStyle: { width: "100%" },
                attrs: {
                  disabled: _vm.readonly,
                  no: "loadingDate",
                  type: "datetime",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  format: "yyyy-MM-dd HH:mm"
                },
                model: {
                  value: _vm.truckingInfo.loadingDate,
                  callback: function($$v) {
                    _vm.$set(_vm.truckingInfo, "loadingDate", $$v)
                  },
                  expression: "truckingInfo.loadingDate"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.satisfiedRequests.visible,
                  expression: "elementDict.satisfiedRequests.visible"
                }
              ],
              attrs: { slot: "satisfiedRequests" },
              slot: "satisfiedRequests"
            },
            [
              _c("special-requests-grid", {
                ref: "selectedSpecialRequest",
                attrs: {
                  "is-edit": _vm.isEdit,
                  "customer-id": _vm.job.customerId,
                  lob: _vm.job.lob,
                  job: _vm.job
                },
                model: {
                  value: _vm.job.satisfiedRequests,
                  callback: function($$v) {
                    _vm.$set(_vm.job, "satisfiedRequests", $$v)
                  },
                  expression: "job.satisfiedRequests"
                }
              })
            ],
            1
          ),
          _vm.elementDict.remarks.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "remarks" }, slot: "remarks" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.remarks.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.remarks.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "110",
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.remarks.label,
                          _vm.job.remarks,
                          function(val) {
                            _vm.job.remarks = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "remarks", $$v)
                      },
                      expression: "job.remarks"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.prePortPlanner &&
          _vm.elementDict.prePortPlanner.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "prePortPlanner" }, slot: "prePortPlanner" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.prePortPlanner.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.prePortPlanner.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "prePortPlanner",
                      disabled: _vm.readonly,
                      "method-params": {
                        category: "role",
                        shape: "sealine",
                        officeId: _vm.$store.getters.currentOfficeId
                      },
                      "default-value": _vm.job.prePortPlanner || "",
                      placeholder: " "
                    },
                    on: { change: _vm.prePortPlannerChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.lastMilePlanner &&
          _vm.elementDict.lastMilePlanner.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "lastMilePlanner" }, slot: "lastMilePlanner" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.lastMilePlanner.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.lastMilePlanner.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "lastMilePlanner",
                      disabled: _vm.readonly,
                      "method-params": {
                        category: "role",
                        shape: "sealine",
                        officeId: _vm.$store.getters.currentOfficeId
                      },
                      "default-value": _vm.job.lastMilePlanner || "",
                      placeholder: " "
                    },
                    on: { change: _vm.lastMilePlannerChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.prePortPlannerDepartment &&
          _vm.elementDict.prePortPlannerDepartment.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "prePortPlannerDepartment" },
                  slot: "prePortPlannerDepartment"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.prePortPlannerDepartment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.prePortPlannerDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "prePortPlannerDepartment",
                      disabled: _vm.readonly,
                      "office-id": Number(_vm.job.prePortPlannerOffice),
                      enables: true,
                      "department-id": Number(_vm.job.prePortPlannerDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.job.prePortPlannerDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.lastMilePlannerDepartment &&
          _vm.elementDict.lastMilePlannerDepartment.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "lastMilePlannerDepartment" },
                  slot: "lastMilePlannerDepartment"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.lastMilePlannerDepartment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.lastMilePlannerDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "lastMilePlannerDepartment",
                      disabled: _vm.readonly,
                      "office-id": Number(_vm.job.lastMilePlannerOffice),
                      enables: true,
                      "department-id": Number(_vm.job.lastMilePlannerDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.job.lastMilePlannerDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.prePortPlannerOffice &&
          _vm.elementDict.prePortPlannerOffice.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "prePortPlannerOffice" },
                  slot: "prePortPlannerOffice"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.prePortPlannerOffice.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.prePortPlannerOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "prePortPlannerOffice",
                      disabled: true,
                      "select-type": _vm.TYPE_NAMES.basic_data_Office,
                      filterable: "",
                      "default-value": _vm.job.prePortPlannerOffice || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.prePortPlannerOffice = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.lastMilePlannerOffice &&
          _vm.elementDict.lastMilePlannerOffice.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "lastMilePlannerOffice" },
                  slot: "lastMilePlannerOffice"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.lastMilePlannerOffice.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.lastMilePlannerOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "lastMilePlannerOffice",
                      disabled: true,
                      "select-type": _vm.TYPE_NAMES.basic_data_Office,
                      filterable: "",
                      "default-value": _vm.job.lastMilePlannerOffice || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.lastMilePlannerOffice = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField1.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedField1" },
                  slot: "userDefinedField1"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField1.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField1.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "111",
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField1.label,
                          _vm.job.userDefinedField1,
                          function(val) {
                            _vm.job.userDefinedField1 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.userDefinedField1,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "userDefinedField1", $$v)
                      },
                      expression: "job.userDefinedField1"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField2.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedField2" },
                  slot: "userDefinedField2"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField2.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField2.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "112",
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField2.label,
                          _vm.job.userDefinedField2,
                          function(val) {
                            _vm.job.userDefinedField2 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.userDefinedField2,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "userDefinedField2", $$v)
                      },
                      expression: "job.userDefinedField2"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField3.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedField3" },
                  slot: "userDefinedField3"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField3.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField3.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "113",
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField3.label,
                          _vm.job.userDefinedField3,
                          function(val) {
                            _vm.job.userDefinedField3 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.userDefinedField3,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "userDefinedField3", $$v)
                      },
                      expression: "job.userDefinedField3"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField4.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedField4" },
                  slot: "userDefinedField4"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField4.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField4.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "114",
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField4.labe,
                          _vm.job.userDefinedField4,
                          function(val) {
                            _vm.job.userDefinedField4 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.userDefinedField4,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "userDefinedField4", $$v)
                      },
                      expression: "job.userDefinedField4"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.taxNature && _vm.elementDict.taxNature.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "taxNature" }, slot: "taxNature" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.taxNature.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.taxNature.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "taxNature",
                        placeholder: _vm.$t("SeaExport.PleaseSelect"),
                        size: "mini"
                      },
                      model: {
                        value: _vm.job.taxNature,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "taxNature", $$v)
                        },
                        expression: "job.taxNature"
                      }
                    },
                    _vm._l(_vm.TAX_NATURES, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.localService.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "localService" }, slot: "localService" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.localService.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.localService.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { display: "block" },
                      attrs: { disabled: _vm.readonly, no: "1" },
                      on: {
                        change: function($event) {
                          return _vm.loadingTerm_Change("warehousing")
                        }
                      },
                      model: {
                        value: _vm.job.warehousing,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "warehousing", $$v)
                        },
                        expression: "job.warehousing"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.WarehouseLoadingStorage"))
                      )
                    ]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { display: "block" },
                      attrs: { disabled: _vm.readonly, no: "2" },
                      on: {
                        change: function($event) {
                          return _vm.loadingTerm_Change("landTransportation")
                        }
                      },
                      model: {
                        value: _vm.job.landTransportation,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "landTransportation", $$v)
                        },
                        expression: "job.landTransportation"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.DoorLoadingDelivery")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { display: "block" },
                      attrs: { disabled: _vm.readonly, no: "3" },
                      model: {
                        value: _vm.job.selfDeliver,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "selfDeliver", $$v)
                        },
                        expression: "job.selfDeliver"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "SeaExport.NotResponsibleForTruckingAndLoading"
                          )
                        )
                      )
                    ]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { display: "block" },
                      attrs: { disabled: _vm.readonly, no: "backUpWarehouse" },
                      model: {
                        value: _vm.job.backUpWarehouse,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "backUpWarehouse", $$v)
                        },
                        expression: "job.backUpWarehouse"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.BackUpWarehouse")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      attrs: { disabled: _vm.readonly, no: "otherService" },
                      model: {
                        value: _vm.job.otherService,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "otherService", $$v)
                        },
                        expression: "job.otherService"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Other")))]
                  ),
                  _c("el-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.job.otherService,
                        expression: "job.otherService"
                      }
                    ],
                    attrs: {
                      disabled: _vm.readonly,
                      no: "otherRemark",
                      maxlength: "10"
                    },
                    model: {
                      value: _vm.job.otherRemark,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "otherRemark", $$v)
                      },
                      expression: "job.otherRemark"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.localService.visible && _vm.job.destinationPortService
            ? _c(
                "el-form-item",
                { attrs: { slot: "localService" }, slot: "localService" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.localService.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.$t("SeaExport.PortOfDestinationServices")
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { display: "block" },
                      attrs: {
                        disabled: _vm.readonly,
                        no: "dischargingPortDoor"
                      },
                      model: {
                        value: _vm.job.dischargingPortDoor,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "dischargingPortDoor", $$v)
                        },
                        expression: "job.dischargingPortDoor"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("SeaExport.DispatchVehiclesAtDestination")
                        ) + " "
                      )
                    ]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { display: "block" },
                      attrs: {
                        disabled: _vm.readonly,
                        no: "destPortCustomsClearance"
                      },
                      model: {
                        value: _vm.job.destPortCustomsClearance,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "destPortCustomsClearance", $$v)
                        },
                        expression: "job.destPortCustomsClearance"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("SeaExport.PortOfDestinationCustomsClearance")
                        ) + " "
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.tradeTerm.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "tradeTerm" }, slot: "tradeTerm" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.tradeTerm.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.tradeTerm.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "tradeTerm",
                      "select-type": _vm.TYPE_NAMES.basic_data_TradeTerm,
                      filterable: "",
                      "default-value": _vm.job.tradeTerm,
                      disabled: _vm.readonly
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.tradeTerm = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.freeDemurrage.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "freeDemurrage" }, slot: "freeDemurrage" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.freeDemurrage.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.freeDemurrage.label
                    },
                    slot: "label"
                  }),
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      controls: false,
                      no: "freeDemurrage"
                    },
                    model: {
                      value: _vm.job.freeDemurrage,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "freeDemurrage", $$v)
                      },
                      expression: "job.freeDemurrage"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.rateType && _vm.elementDict.rateType.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "rateType" }, slot: "rateType" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.rateType.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.rateType.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "rateType",
                        clearable: "",
                        placeholder: _vm.$t("SeaExport.PleaseSelect"),
                        size: "mini"
                      },
                      model: {
                        value: _vm.job.rateType,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "rateType", $$v)
                        },
                        expression: "job.rateType"
                      }
                    },
                    _vm._l(_vm.rateType, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _c("bill-address-dialog", {
        attrs: {
          visible: _vm.billAddressDialog.visible,
          job: _vm.job,
          "own-permission": _vm.hasChooseOwnTransceiverPermission,
          "customer-cmp-list": _vm.customerCmpList,
          "use-empty-customer-cmp-list": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              disabled: _vm.readonly,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-uppercase": _vm.advanceTextDialog.formatObj.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "115", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "116" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("transcribe-dialog", {
        attrs: { visible: _vm.transcribeDialog.visible, job: _vm.job },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.transcribeDialog, "visible", $event)
          },
          callback: _vm.transcribeCallback
        }
      }),
      _c("hs-code-search-dialog", {
        attrs: {
          visible: _vm.hsCodeSearchDialog.visible,
          title: _vm.hsCodeSearchDialog.title
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.hsCodeSearchDialog, "visible", $event)
          },
          callback: _vm.hsCodeSearchDialog.successCallback
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }